<template>
	<div class="pages">
		<div class="introductionTop">
			<div class="flex flex-align-center flex-jus-between">
				<img src="../../../static/images/icon-arrowLeft.png" class="arrow" @click="goBack"/>
				<img src="../../../static/images/icon-my.png" class="arrow" @click="$router.push({name: 'my'})"/>
			</div>
			<div class="avatar flex flex-align-center flex-jus-center"><img src="../../../static/images/logo_transparent.png" alt="" /></div>
			<div class="name">福建省民族管弦乐学会</div>
		</div>
		<template >
			<div>
				<div class="navTitle flex flex-align-center flex-jus-between">
					<div v-for="(item, index) in tabList" @click="changeTab(item, index)" :key="index" class="navTitle-item flex-1" :class="{'navTitle-itemActive': index == tabIndex}">{{item.title}}</div>
				</div>
				<div class="content">
					<div class="title">{{title}}</div>
					<div class="dialog-h5" v-html="content"></div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	/* eslint-disable */
	export default {
		watch: {
		},
		data() {
			return{
				tabIndex: 0,
				tabList: [],
				title: '',
				content: ''
			}
		},
		created() {
			this.getData()
		},
		mounted() {
			this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '学会简介',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
		},
		methods: {
			goBack() {
				if (window.history.length <=1 ) {
					this.$router.push('/home')
				} else {
					this.$router.back(-1)
				}
			},
			getData() {
				this.$get('api/actile/getLearnBrief').then(res => {
					this.tabList = res.data
					this.title = this.tabList[0].tag
					this.content = this.tabList[0].content
				})
			},
			changeTab(data, index) {
				this.title = data.title
				this.content = data.content
				this.tabIndex = index
			}
		}
	}
</script>
<style scoped>
	.dialog-h5 >>> img {
		max-width: 100%;
		height: auto;
	}
</style>
<style scoped lang="stylus">
.pages
	background-color #FFFFFF
.introductionTop
	background-image url('../../../static/images/my/applyBG.png')
	background-size 100% 100%
	background-position center
	width 100vw
	height 420px
	padding 24px 30px
	.arrow
		width 52px
		height 52px
	.avatar
		width 100px
		height 100px
		margin 0 auto
		background-color #FFFFFF
		border-radius 50%
		img
			width 84px
			height 84px
			margin-left 1px
			border-radius 50%
	.name
		margin-top 26px
		text-align center
		width 100%
		font-size 32px
		font-weight 800
		color #FFEBE8
.navTitle
	margin-top -42px
	width 100%
	height 102px
	border-bottom 1px solid #ECECEC;
	padding 32px 16px 16px 16px
	border-radius: 40px 40px 0px 0px;
	background-color #FFFFFF
	text-align center
	.navTitle-item
		font-size: 28px;
		font-weight: 500;
		color: #000000;
	.navTitle-itemActive
		font-size: 28px;
		font-weight: 800;
		color: #DE113C;
		position relative
		&::after
			content ' '
			position absolute
			width: 78px;
			height: 6px;
			background: #DE113C;
			left calc(50% - 39px)
			bottom -20px
.content
	padding 40px 30px
	overflow-y auto
	max-height calc(100vh - 480px)
	font-size: 30px;
	color: #333333;
	.title
		width 100%
		text-align center
		font-size: 30px;
		font-weight: bold;
		color: #111111;
		margin-bottom 28px
</style>
